module.exports = __webpack_public_path__ + "img/goldmesaj-logo.f2280812.svg";